import React from 'react'
import PropTypes from 'prop-types'

const SeoMedia = (props) => {
  const { title, description, image, url } = props

  return (
    <>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={image} />
      <meta name="twitter:card" content="summary with large image" />
    </>
  )
}

SeoMedia.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.array,
  url: PropTypes.string,
}

export default SeoMedia
